import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './delivery-options.scss';
import DeliveryOptionsForm from '../delivery-options-form/delivery-options-form';
import OrderSummary from '../order-summary/order-summary';
import { setDeliveryOption, setSingleShippingAddress } from '../../../../actions/cashActions';
import MobileOrderSummary from '../mobile-order-summary/mobile-order-summary';

/**
 * Delivery options step in AmpolCash order modal flow
 * @param cashOrderCartItems The key/value pair object containing cart items
 * @param cashCartSubTotal The subtotal for the cart items
 * @param cashOrderDefaults Default cash order values for account
 * @param selectedDeliveryOption The selected delivery option
 * @param formId Form unique id
 * @param singleShippingAddress Details for single shipping address
 * @param recipientsAddClick parent event
 * @param recipientsEditClick parent event
 * @param recipientsRemoveClick parent event
 * @param addEditAmpolCash onClick event for Add/Edit AmpolCash option
 * @param onDeliveryOptionsContinue onDeliveryOptionsContinue event
 * @param onDeliveryOptionsFChange onDeliveryOptionsChange event
 * @returns JSX Element
 */
const DeliveryOptions = ({ cashOrderCartItems, cashCartSubTotal, cashOrderDefaults, selectedDeliveryOption, formId, singleShippingAddress,
  recipientsAddClick, recipientsEditClick, recipientsRemoveClick, addEditAmpolCash, onDeliveryOptionsContinue, onDeliveryOptionsChange }) => {
  const dispatch = useDispatch();

  const stepId = useSelector((state) => state.cashStore.cashModalStepId);


  const onSubmit = (values) => {
    dispatch(setSingleShippingAddress(values));
    onDeliveryOptionsContinue(true);
  };

  const handleDeliveryOptionsFormChange = (option, isValid) => {
    dispatch(setDeliveryOption(option));
    onDeliveryOptionsChange(option, isValid, stepId);
  };

  return <>
    <MobileOrderSummary
      cashOrderCartItems={cashOrderCartItems}
      cashCartSubTotal={cashCartSubTotal}
      addEditAmpolCash={addEditAmpolCash}
    />
    <div className="delivery-options__container">
      <div className="delivery-options__grid-cell">
        <DeliveryOptionsForm
          cashOrderCartItems={cashOrderCartItems}
          cashOrderDefaults={cashOrderDefaults}
          selectedDeliveryOption={selectedDeliveryOption}
          formId={formId}
          singleShippingAddress={singleShippingAddress}
          onSubmit={onSubmit}
          recipientsAddClick={recipientsAddClick}
          recipientsEditClick={recipientsEditClick}
          recipientsRemoveClick={recipientsRemoveClick}
          onChange={handleDeliveryOptionsFormChange}
        />
      </div>
      <div className="delivery-options__grid-cell delivery-options__order-summary">
        <OrderSummary
          cashOrderCartItems={cashOrderCartItems}
          cashCartSubTotal={cashCartSubTotal}
          addEditAmpolCash={addEditAmpolCash}
        />
      </div>
    </div>
  </>;
};

export default DeliveryOptions;
